// extracted by mini-css-extract-plugin
export var printerCard = "_bu-1";
export var printerCardConfigured = "_bu-2";
export var printerCardError = "_bu-3";
export var printerCardsContainer = "_bu-0";
export var printerIcon = "_bu-8";
export var printerIconConfigured = "_bu-5";
export var printerIconContainer = "_bu-4";
export var printerIconError = "_bu-6";
export var printerIconUnconfigured = "_bu-7";
export var workstationsTableCard = "_bu-9";